import { UserAnswers, RecommendationsData, QuestionnaireResponse } from '@/machines/types';
import { api } from '../api';

export const getAllQuestions = async (url = ''): Promise<QuestionnaireResponse> => {
  const { data } = await api.get<QuestionnaireResponse>(`${url}/api/v1/product-recommender/general-health`);

  return data;
};

export const submitAllAnswers = async (answers: UserAnswers): Promise<RecommendationsData> => {
  const { data } = await api.post<RecommendationsData>('/api/v1/product-recommender/answers', {
    answers,
  });

  return data;
};
